// src/admin/adminBillingUtils.js
// ============================================================================
// ✅ READ ME (Billing Helpers)
// This file contains helper utilities used by the Admin Billing tab.
// If you need to tweak date formatting, money formatting, or clamping logic,
// THIS is where you do it.
//
// Used by: /src/components/admin/AdminBillingTab.js
// ============================================================================

export const formatDate = (value) => {
    if (!value) return null;
    let d = null;
  
    if (typeof value === "object" && value !== null) {
      if (value.toDate) d = value.toDate();
      else if (value.seconds) d = new Date(value.seconds * 1000);
    } else if (typeof value === "number") {
      d = new Date(value * 1000);
    } else if (typeof value === "string") {
      d = new Date(value);
    }
  
    if (!d || Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString();
  };
  
  export const computeDaysRemaining = (value) => {
    if (!value) return null;
    let endDate = null;
  
    if (typeof value === "object" && value !== null) {
      if (value.toDate) endDate = value.toDate();
      else if (value.seconds) endDate = new Date(value.seconds * 1000);
    } else if (typeof value === "number") {
      endDate = new Date(value * 1000);
    } else if (typeof value === "string") {
      endDate = new Date(value);
    }
  
    if (!endDate || Number.isNaN(endDate.getTime())) return null;
  
    const now = new Date();
    const diffMs = endDate.getTime() - now.getTime();
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  };
  
  export const money = (amountMinor, currency) => {
    const amt = Number(amountMinor || 0) / 100;
    const cur = (currency || "usd").toUpperCase();
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: cur,
      }).format(amt);
    } catch {
      return `${cur} ${amt.toFixed(2)}`;
    }
  };
  
  export const clampInt = (v, min = 0) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return min;
    return Math.max(min, Math.floor(n));
  };
  